import type React from "react";
import { useStores } from "../../hooks/useStores";
import { useProducts } from "../../hooks/useProducts";

interface Props {
  onFilterChange: (filters: any) => void;
}

const SalesFilters: React.FC<Props> = ({ onFilterChange }) => {

    const { stores } = useStores();
    const { products } = useProducts();

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-3 bg-white p-4 rounded-xl border">
      <input
        type="date"
        className="form-input"
        onChange={(e) => onFilterChange({ startDate: e.target.value })}
      />

      <input
        type="date"
        className="form-input"
        onChange={(e) => onFilterChange({ endDate: e.target.value })}
      />

      <select
        className="form-input"
        onChange={(e) => onFilterChange({ storeId: e.target.value })}
      >
        <option value="">All Stores</option>
        {
            stores.map((store) => (
                <option 
                    key={store.id}
                    value={store.id}
                >
                    {store.name}
                </option>
            ))
        }
      </select>

      <select
        className="form-input"
        onChange={(e) => onFilterChange({ productId: e.target.value })}
      >
        <option value="">All Products</option>
         {
            products.map((product) => (
                <option 
                    key={product.id}
                    value={product.id}
                >
                    {product.name}
                </option>
            ))
        }
      </select>
    </div>
  );
};

export default SalesFilters;
